import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export function errMsg(e, fallback = "Something went wrong. Please try again.") {
  if (!e?.response) return "Couldn't reach the courtyard. Check your connection and try again.";
  const d = e.response.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => String(x?.msg || "").replace(/^Value error, /, "")).filter(Boolean).join(" ") || fallback;
  return fallback;
}

export const photoSrc = (id) => `${API}/photos/${id}/image`;
